<div class="container mx-auto p-4">
  <h2 class="text-2xl font-bold mb-4">Investment Consultations</h2>

  <div class="filters-section mb-4">
    <div class="relative">
        <input type="text" pInputText placeholder="Search by name, email, or phone..." [(ngModel)]="searchTerm" (input)="onSearch()" class="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 pr-10">
        <button *ngIf="searchTerm" (click)="clearSearch()" class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 hover:text-gray-700">
            <i-lucide name="x" class="h-5 w-5"></i-lucide>
        </button>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading consultations...</p>
  </div>

  <div *ngIf="!loading">
    <p-table [value]="consultations" [paginator]="true" [rows]="10" [totalRecords]="totalRecords" (onPage)="loadConsultations($event)" [lazy]="true" styleClass="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Preferred Office</th>
          <th>Description</th>
          <th>Date</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-consultation>
        <tr>
          <td>{{ consultation.name }}</td>
          <td>{{ consultation.email }}</td>
          <td>{{ consultation.phone }}</td>
          <td>{{ consultation.preferredOffice }}</td>
          <td>{{ consultation.description }}</td>
          <td>{{ consultation.createdAt | date: 'short' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6" class="text-center py-8 text-gray-400">No consultations found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

